import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientWholesalerEntity } from './client-wholesaler.entity';

@Index('wholesaler_pk', ['name'], { unique: true })
@Entity('wholesaler')
export class WholesalerEntity extends BaseEntity {
	@Column('varchar', { name: 'name', unique: true, length: 255 })
	public name!: string;

	@Column('varchar', { name: 'externalId', nullable: true, length: 255 })
	public externalId!: string | null;

	@OneToMany(
		() => ClientWholesalerEntity,
		(clientWholesaler) => clientWholesaler.fkWholesaler,
		{},
	)
	public clientWholesalers!: Array<ClientWholesalerEntity>;
}
